
namespace SorAraBul.Definitions {
    export class CitiesColumns {
        static columnsKey = 'Definitions.Cities';
    }
}